import React, { useEffect, useState } from 'react';
import { Card, CardContent } from '@mui/material';
import { BarChart } from '@mui/x-charts';

import '../ApplicantsNewDashboard.css';
import CardTitle from '../CardTitle/CardTitle';

const LinearProgressGraphWidgetCard = ({
  card,
  showToggle = false,
  switchChange,
  editMode,
  handleSaveCardTitle,
  handleDeleteCard,
  handleEditCard,
  handleCardTitle,
  cardTitleChangeId,
}) => {
  const data = card?.data || [];

  return (
    <Card className="dashboard__card">
      <CardTitle
        card={card}
        editMode={editMode}
        handleSaveCardTitle={handleSaveCardTitle}
        handleDeleteCard={handleDeleteCard}
        handleEditCard={handleEditCard}
        handleCardTitle={handleCardTitle}
        cardTitleChangeId={cardTitleChangeId}
      />
      <CardContent style={{ position: 'relative' }}>
        {data.length > 0 ? (
          <BarChart
            dataset={data}
            yAxis={[{ scaleType: 'band', dataKey: 'recruiterName' }]}
            margin={{ left: 100 }}
            grid={{ horizontal: true }}
            slots={{ legend: () => null }}
            series={[
              {
                dataKey: 'count',
                label: 'Uploaded',
                // colorKey: "#808080",
                barLabel: (value) => `${value}`,
              },
            ]}
            layout="horizontal"
            colors={['#808080']} // force grey for all bars
            height={data.length === 1 ? 140 : data.length * 100}
            // barLabel= {"value"}
          />
        ) : (
          <div className="dashboard__card-no-data-container">
            No data available
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default React.memo(LinearProgressGraphWidgetCard);
